/**
 * @file automatically generated from MApp.Spatial.Ogc.OperationType
 */

export enum OperationType {
    GetCapabilities = 0,
    GetTile = 1,
    GetFeatureInfo = 2,
    GetMap = 3,
    GetFeature = 4
}
